/**
 * Overlay stack. Modals and drawers register while open, so keyboard
 * handling belongs to the topmost one only: Escape in a confirm dialog
 * closes the dialog, not the drawer underneath it, and Tab is trapped in
 * the layer the user is actually in.
 */

const stack: symbol[] = [];

export function pushOverlay(): symbol {
  const token = Symbol("overlay");
  stack.push(token);
  return token;
}

export function popOverlay(token: symbol): void {
  const i = stack.lastIndexOf(token);
  if (i >= 0) stack.splice(i, 1);
}

export function isTopOverlay(token: symbol | null): boolean {
  return token !== null && stack[stack.length - 1] === token;
}

/**
 * True while a popup opened from inside `root` is showing (a select menu, a
 * date picker, a dropdown). Its trigger carries `aria-haspopup` and
 * `aria-expanded="true"`; Escape then belongs to the popup, not the overlay.
 */
export function hasOpenPopup(root: HTMLElement | null): boolean {
  return Boolean(root?.querySelector('[aria-haspopup][aria-expanded="true"]'));
}
